import { User as UserIcon } from 'lucide-react';
import { cn } from '@/lib/cn';
import { OnlineIndicator } from './OnlineIndicator';

interface AvatarProps {
  src?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  /** When true, renders a green "online" dot on the bottom-right of the avatar. */
  isOnline?: boolean;
}

const sizes = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
  xl: 'h-16 w-16',
};

export function UserAvatar({ src, size = 'md', className, isOnline }: AvatarProps) {
  return (
    <div className={cn(sizes[size], 'rounded-full bg-neutral-200 dark:bg-neutral-800 flex items-center justify-center overflow-hidden relative', className)}>
      {src ? (
        <img src={src} alt="Avatar" className="object-cover w-full h-full" />
      ) : (
        <div className="flex items-center justify-center h-full w-full text-neutral-400">
          <UserIcon size={size === 'xl' ? 24 : size === 'lg' ? 20 : size === 'md' ? 16 : 12} />
        </div>
      )}
      {isOnline && <OnlineIndicator isOnline size={size === 'xl' ? 'md' : 'sm'} />}
    </div>
  );
}
